import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import EvaluationFormComponent from '../../../components/CRM/ExpertCRM/EvaluationForm/EvaluationForm.component'
import { PATH_EXPERT_DASHBOARD } from '../../../const/routes.const'
import { EvaluateForm, EvaluateRequest, EvaluationValuationModel } from '../../../models/ExpertModels/Evaluation.model'
import { GrantType } from '../../../models/ArtistModels/artistForm.model'
import { evaluateArtist, getEvaluationInfo } from '../../../services/expert/expertEvaluation.service'
import { evaluateRequestStore, evaluationInfoGetStore } from '../../../store/ExpertStore/ExpertEvaluation.store'
import { getEvaluatedArtist } from '../../../services/expert/expertDashboard.service'

const EvaluationFormContainer = (props: RouteComponentProps): JSX.Element => {
  const [id, setId] = useState<number>()
  const [formData, setFormData] = useState<EvaluationValuationModel>()
  const [grantType, setGrantType] = useState<GrantType | null | undefined>()

  const evaluate = (data: EvaluateForm): void => {
    const preparedRequest: EvaluateRequest = {
      reality: parseInt(data.reality),
      relevance: parseInt(data.relevance),
      quality: parseInt(data.quality),
      emotionalResponse: parseInt(data.emotionalResponse),
      comment: data.comment || undefined
    }

    evaluateArtist(preparedRequest, id ?? evaluationInfoGetStore.evaluationInfo?.valuation.id ?? 0).then(() => {
      props.history.push(PATH_EXPERT_DASHBOARD)
    })
  }

  useEffect(() => {
    const id = Number(window.location.search.split('=')[1])

    if (id) {
      getEvaluatedArtist(id).then((res) => {
        if (res) {
          setFormData(res.valuation)
          setGrantType(res.artist.grantType)
        }
      })
      setId(id)
    } else {
      getEvaluationInfo().then((res) => {
        if (res) {
          setFormData(res.valuation)
          setGrantType(res.artist.grantType)
        }
      })
    }
  }, [])


  return (
    <EvaluationFormComponent
      onSubmit={evaluate}
      formData={formData}
      grantType={grantType}
      isLoading={evaluateRequestStore.isLoading}
      error={evaluateRequestStore.requestErrors && evaluateRequestStore.requestErrors[0].message}
    />
  )
}

export default withRouter(observer(EvaluationFormContainer))